import React, { useContext, useEffect, useState } from 'react'
import lookup from '../../../../assets/certificates/Tables/lookup.svg'
import editPen from '../../../../assets/certificates/Tables/pencil.svg'
import { GlobalTable, HeaderLine, Td, TdButtons, Th, Tr, FooterTr } from '../../../../components/styles/table-style'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { CertificateOutletType } from '..'
import axios from '../../../../config/axios'
import UserContext from '../../../../contexts/UserContext'

interface CertificateTypeForTable {
  id: number,
  param: string
  supplier: string
  customer: string
  heatNumber: string
  type: string
  date: string
}

const CertificatesTable: React.FC = () => {
  const [ certificates, setCertificates ] = useState<CertificateTypeForTable[]>([])
  const [ visibleCount, setVisibleCount ] = useState<number>(10)
  const [ totalCount, setTotalCount ] = useState<number | null>(null)
  const { setTabIndex, appliedFilters, search } = useOutletContext<CertificateOutletType>()
  const navigate = useNavigate()
  const { user } = useContext(UserContext)
  
  
  useEffect(() => {
    setTabIndex(0)
  }, [])
  
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/certificates/certificate`, {
      params: { filters: appliedFilters, search: search, limit: visibleCount, offset: 0 },
    })
      .then(response => {

        if (response.data) {
          if (Array.isArray(response.data)) {
            setCertificates(response.data)
            setTotalCount(response.data.length)
          } else if (response.data.data) {
            setCertificates(response.data.data)
            setTotalCount(response.data.total ?? response.data.data.length)
          }
        }
      })
      .catch(error => {
        console.error(error)
      })
  }, [appliedFilters, search, visibleCount])
  
  const columns = ['Parâmetro', 'Fornecedor', 'Cliente', 'Tipo do certificado', 'Nº da corrida', 'Data de criação']

  return (
    <GlobalTable>
      <thead>
        <HeaderLine>
          {columns.map((item, colIndex) => (
            <Th key={colIndex}>{item}</Th>
          ))}
          <Th></Th>
        </HeaderLine>
      </thead>
      <tbody>
        {certificates.map((certificate, index) => 
          <Tr key={index}>
            <Td>{certificate.param}</Td>
            <Td>{certificate.supplier}</Td>
            <Td>{certificate.customer}</Td>
            <Td>{certificate.type}</Td>
            <Td>{certificate.heatNumber}</Td>
            <Td>{certificate.date}</Td>
            <TdButtons>
              <img src={lookup} alt='looup-icon' onClick={() => navigate(`view/${certificate.id}`)} />
              <img src={editPen} alt='edit-icon' onClick={() => navigate(`edit?id=${certificate.id}`)} />
            </TdButtons>
          </Tr>
        )}
        </tbody>
        <tfoot>
          <FooterTr>
            <Td colSpan={columns.length + 1} style={{ textAlign: 'center', background: 'transparent' }}>
              <LoadMoreButton
                currentCount={certificates.length}
                totalCount={totalCount ?? certificates.length}
                onLoadMore={() => setVisibleCount(prev => prev + 10)}
                hasMore={typeof totalCount === 'number' ? certificates.length < totalCount : false}
              />
            </Td>
          </FooterTr>
        </tfoot>
      </GlobalTable>
  )
}
export default CertificatesTable